import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');

let Service = {
  /**
   * 查询关注门店状态接口
   * @params {String} storeCode    门店编码
   * @return Promise
   * */
  queryFocusStore(storeCode){
    let url = CONF.API.queryFocusStore,
      jsonpCallback = 'queryFocusStoreCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询关注门店状态接口
   * @params {String} storeCode    门店编码
   * @return Promise
   * */
  addFocusStore(params){
    let url = CONF.API.addFocusStore;

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        params: params
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        }
        else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询关注门店状态接口
   * @params {String} storeCode    门店编码
   * @return Promise
   * */
  delFocusStore(params){
    let url = CONF.API.delFocusStore;

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        params: params
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 门店基础信息
   * @params {String} storeCode    门店编码
   * @return Promise
   * */
  queryStoreInfo(storeCode){
    let url = CONF.API.storeInfo,
      jsonpCallback = 'queryStoreInfoCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '1') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询电器城热销商品种类TAB
   * @params {String} storeCode   门店编码
   * @params {String} cityId      城市编码
   * @return Promise
   * */
  queryBeterTabs(storeCode, cityCode){
    let url = CONF.API.queryBeterTabs,
      jsonpCallback = 'queryBeterTabsCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询红孩子、精选店商品种类TAB
   * @params {String} storeCode   门店编码
   * @return Promise
   * */
  queryRedTabs(storeCode){
    let url = CONF.API.queryRedTabs,
      jsonpCallback = 'queryRedTabsCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询维修中心商品种类TAB
   * @params {String} storeCode   门店编码
   * @return Promise
   * */
  queryRepairTabs(storeCode){
    let url = CONF.API.queryRepairTabs,
      jsonpCallback = 'queryRepairTabsCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 查询优趣店 、体育店  商品TAB
   * @params {String} storeCode   门店编码
   * @return Promise
   * */
  queryYouTabs(storeCode){
    let url = CONF.API.parameterUrl,
      jsonpCallback = 'queryYouTabsCallback';
    url = url
      .replace('{{parentParameterId}}', storeCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 根据种类，查询电器城热销商品列表
   * @params {String} storeCode   门店编码
   * @params {String} cityId      城市编码
   * @params {String} catalogueId 商品组编码
   * @return Promise
   * */
  queryBeterList(storeCode, cityCode, cateId){
    let url = CONF.API.queryBeterList,
      jsonpCallback = 'queryBeterListCallback';
    url = url
      .replace('{{storeCode}}', storeCode)
      .replace('{{cityCode}}', cityCode)
      .replace('{{cateId}}', cateId)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 根据种类，查询红孩子、精选店、优趣店、体育店  商品列表
   * @params {String} catalogueId 商品组编码
   * @params {String} storeCode   门店编码
   * @params {String} pageNum     分页编码
   * @return Promise
   * */
  queryRedList(storeCode, cateId, pageNum){
    let url = CONF.API.queryRedList,
      jsonpCallback = 'queryRedListCallback';
    url = url
      .replace('{{cateId}}', cateId)
      .replace('{{storeCode}}', storeCode)
      .replace('{{pageNum}}', pageNum)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 根据种类，查询维修中心商品列表
   * @params {String} catalogueId 商品组编码
   * @params {String} storeCode   门店编码
   * @params {String} pageNum     分页编码
   * @return Promise
   * */
  queryRepairList(cateId){
    let url = CONF.API.queryRepairList,
      jsonpCallback = 'queryRepairListCallback';
    url = url
      .replace('{{cateId}}', cateId)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/StorePage.js